export const Footer = () => {
  return (
    <footer
      className="relative bg-[var(--bb-bg)] border-t border-[var(--bb-border)] pt-16 pb-10"
      data-testid="footer"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        <div className="flex flex-col gap-10">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
            <div className="md:col-span-5">
              <div className="mono-label mb-4">[ MANIFIESTO ]</div>
              <p className="font-serif-italic text-xl md:text-2xl text-[var(--bb-text)] leading-snug max-w-md">
                “Arquitectado para la perfección. Desplegado para el impacto.”
              </p>
            </div>

            <div className="md:col-span-3 md:col-start-7">
              <div className="mono-label mb-4">Navegación</div>
              <ul className="flex flex-col gap-3 font-mono text-[12px] tracking-[0.18em] uppercase">
                <li><a href="#about" className="bb-link">Sobre Nosotros</a></li>
                <li><a href="#services" className="bb-link">Servicios</a></li>
                <li><a href="#contact" className="bb-link">Contacto</a></li>
              </ul>
            </div>

            <div className="md:col-span-3">
              <div className="mono-label mb-4">Canales</div>
              <ul className="flex flex-col gap-3 font-mono text-[12px] tracking-[0.18em] uppercase">
                <li><a href="#" className="bb-link" data-testid="footer-linkedin">LinkedIn</a></li>
                <li><a href="#" className="bb-link" data-testid="footer-github">GitHub</a></li>
                <li><a href="#" className="bb-link">Privacidad</a></li>
                <li><a href="#" className="bb-link">Términos</a></li>
              </ul>
            </div>
          </div>

          <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4 pt-10 border-t border-[var(--bb-border)]">
            <div className="mono-label">
              © {new Date().getFullYear()} BLACK BELTS AI · ARQUITECTADO PARA LA PERFECCIÓN
            </div>
            <div className="mono-label text-[var(--bb-copper)]">
              MADRID · 40.4168°N / 3.7038°W
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
